// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "b,body,h1,h2,h3,h4,h5,h6,html,p,ul{margin:0;padding:0;font-weight:400}body,button,input,textarea{font-family:PingFangSC-Regular,PingFang SC,Helvetica Neue,Arial,sans-serif!important}a{color:inherit;text-decoration:none}li,ul{list-style:none}button{outline:none;cursor:pointer}button:active{opacity:.6}", ""]);
// Exports
module.exports = exports;
